import React, { useEffect, useState } from 'react'
import { confirmModal } from '../../../../helpers/PromptUtils';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import axios from 'axios';
import { getToken } from '../../../../helpers/Jwt';
import * as Yup from 'yup';


const EntryFileReception = () => {
    const { queue } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_FILE_RECEPTION = "api/kejati/dashboard/FileReception";

    const onSubmit = async (values, { setSubmitting }) => {
        try {
            const payload = {
                queue,
                ...values
            };

            const response = await axios.post(`${BASE_URL}${PATH_FILE_RECEPTION}`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getToken()}`
                }
            });

            const { message, redirect } = response.data;

            const confirmed = confirmModal(message);
            if (confirmed) {
                navigate(redirect);
                // window.location.reload();
            }
        } catch (error) {
            alert(error.response.data);
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
        if (queue == null) {
            navigate(`/activity-kejati/dashboard`);
        }
    }, [queue]);

    const initialValues = {

    };

    const validationSchema = Yup.object({
    });

    return (
        <div>

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({ values, handleChange, setFieldValue, isSubmitting }) => (
                    <Form>
                        <div className="container m-auto">

                            <h1 className='p-3'>No. Antrian <span className='font-bold'>{queue}</span></h1>

                            <div className="px-3 py-2">
                                <label htmlFor="type" className="mb-1 text-sm font-semibold">Jenis Dokumen</label>
                                <Field
                                    name="type"
                                    placeholder="Jenis Dokumen"
                                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                />
                                <ErrorMessage name="type" component="p" className="text-red-500 text-xs mt-1" />
                            </div>

                            <div className="px-3 py-2">
                                <label htmlFor="number" className="mb-1 text-sm font-semibold">Nomor Dokumen</label>
                                <Field
                                    name="number"
                                    placeholder="Nomor Dokumen"
                                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                />
                                <ErrorMessage name="number" component="p" className="text-red-500 text-xs mt-1" />
                            </div>
                            <div className='flex flex-row'>
                                <div className="px-3 py-2 flex-1">
                                    <label htmlFor="sender" className="mb-1 text-sm font-semibold">Pengirim Berkas</label>
                                    <Field
                                        name="sender"
                                        placeholder="Pengirim Berkas"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    />
                                    <ErrorMessage name="sender" component="p" className="text-red-500 text-xs mt-1" />
                                </div>

                                <div className="px-3 py-2 flex-1">
                                    <label htmlFor="phone_sender" className="mb-1 text-sm font-semibold">Whatsapp Pengirim Berkas</label>
                                    <Field
                                        name="phone_sender"
                                        placeholder="Whatsapp Pengirim Berkas"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    />
                                    <ErrorMessage name="phone_sender" component="p" className="text-red-500 text-xs mt-1" />
                                </div>
                            </div>


                            <div className='flex flex-row'>
                                <div className="px-3 py-2 flex-1">
                                    <label htmlFor="receiver" className="mb-1 text-sm font-semibold">Penerima Berkas</label>
                                    <Field
                                        name="receiver"
                                        placeholder="Penerima Berkas"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    />
                                    <ErrorMessage name="receiver" component="p" className="text-red-500 text-xs mt-1" />
                                </div>

                                <div className="px-3 py-2 flex-1">
                                    <label htmlFor="phone_receiver" className="mb-1 text-sm font-semibold">Whatsapp Penerima Berkas</label>
                                    <Field
                                        name="phone_receiver"
                                        placeholder="Whatsapp Penerima Berkas"
                                        className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    />
                                    <ErrorMessage name="phone_receiver" component="p" className="text-red-500 text-xs mt-1" />
                                </div>
                            </div>

                            <div className="px-3 py-2">
                                <label htmlFor="status" className="mb-1 text-sm font-semibold">Status Berkas</label>
                                <Field
                                    as="select"
                                    name="status"
                                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                                    onChange={(e) => setFieldValue(`status`, e.target.value)}
                                >
                                    <option value="">Pilih Status</option>
                                    <option value="Terima">Terima</option>
                                    <option value="Tidak Diterima">Tidak Diterima</option>
                                </Field>
                            </div>


                            <div className="px-3 py-2 flex items-center justify-end mt-5">
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                        }`}
                                >
                                    {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default EntryFileReception;